import Step1 from './step-1'
import Step2 from './step-2'
import Step3 from './step-3'
import Step4 from './step-4'

export default function StepContent({
	quarter,
	// Main State
	activeStep: step,
	hasMobile,
	// Standard Report Form Handler State
	flags,
	needToFillFormType,
	filledFormAmount,
	currentFilledFormIndex,
	onFillForm,
	// Standard Report Answers
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	fixedGeneralDetails,
	fixedInfoDetails,
	fixedSoundDetails,
	mobileGeneralDetails,
	mobileInfoDetails,
	mobileSoundDetails,
	// Step 1
	userOperatorProfile,
	reportMethod,
	reportVersion,
	onChangeRadio,
	fixedReportTypeRadioValue,
	mobileReportTypeRadioValue,
	onChangeReportType,
	setVersion,
	hasEverSubmitedForm,
	isNewForm,
	onChangeIsContinueRadio,
	continueFormSubmittedType,
	currentHeadData,
	// Step 2 Upload File
	excelFile,
	setExcelFile,
	excelFileShow,
	setExcelFileShow,
	// Step 3 Additional Files
	mobileFiles,
	mobileAdditionalFiles,
	onInputAdditionalFile,
	onDeleteAdditionalFile,
	// Step 4 Validation
	invalidDataSetRecords,
	invalidAnswers,
	onInputValidationReason,
	invalidInputMethod,
	onChangeInvalidaInputMethod,
	openAskingValidationModal,
	onOpenAskingValidationModal,
	onCloseAskingValidationModal,
	onAskInvalidInputMethod,
	currentValiationQuestionNumber,
	openFillingModal,
	currentSelectedItem,
	onCloseFillingModal,
	userOverride,
	onReValidate,
	previewAnswers,
	setPreviewAnswers,
}) {

	return (
		<>
			{step === 0 && (
				<Step1
					fixedReportTypeRadioValue={fixedReportTypeRadioValue}
					mobileReportTypeRadioValue={mobileReportTypeRadioValue}
					onChangeReportType={onChangeReportType}
					setVersion={setVersion}
					reportMethod={reportMethod}
					reportVersion={reportVersion}
					onChangeRadio={onChangeRadio}
					userOperatorProfile={userOperatorProfile}
					hasEverSubmitedForm={hasEverSubmitedForm}
					isNewForm={isNewForm}
					onChangeIsContinueRadio={onChangeIsContinueRadio}
					continueFormSubmittedType={continueFormSubmittedType}
					currentHeadData={currentHeadData}
					userOverride={userOverride}
				/>
			)}

			{step === 1 && (
				<Step2
					quarter={quarter}
					flags={flags}
					needToFillFormType={needToFillFormType}
					filledFormAmount={filledFormAmount}
					currentFilledFormIndex={currentFilledFormIndex}
					onFillForm={onFillForm}
					fixedGeneralAnswers={fixedGeneralAnswers}
					fixedInfoAnswers={fixedInfoAnswers}
					fixedSoundAnswers={fixedSoundAnswers}
					mobileGeneralAnswers={mobileGeneralAnswers}
					mobileInfoAnswers={mobileInfoAnswers}
					mobileSoundAnswers={mobileSoundAnswers}
					reportMethod={reportMethod}
					reportVersion={reportVersion}
					// Upload File
					excelFile={excelFile}
					setExcelFile={setExcelFile}
					excelFileShow={excelFileShow}
					setExcelFileShow={setExcelFileShow}
					previewAnswers={previewAnswers}
					setPreviewAnswers={setPreviewAnswers}
					userOverride={userOverride}
				/>
			)}

			{hasMobile && step === 2 && (
				<Step3
					mobileFiles={mobileFiles}
					mobileAdditionalFiles={mobileAdditionalFiles}
					onInputAdditionalFile={onInputAdditionalFile}
					onDeleteAdditionalFile={onDeleteAdditionalFile}
				/>
			)}

			{((step === 3 && hasMobile) || (step === 2 && !hasMobile)) && (
				<Step4
					formType={needToFillFormType}
					invalidDataSetRecords={invalidDataSetRecords}
					invalidAnswers={invalidAnswers}
					onInputValidationReason={onInputValidationReason}
					invalidInputMethod={invalidInputMethod}
					onChangeInvalidaInputMethod={onChangeInvalidaInputMethod}
					openAskingValidationModal={openAskingValidationModal}
					onOpenAskingValidationModal={onOpenAskingValidationModal}
					onAskInvalidInputMethod={onAskInvalidInputMethod}
					currentValiationQuestionNumber={currentValiationQuestionNumber}
					openFillingModal={openFillingModal}
					onCloseAskingValidationModal={onCloseAskingValidationModal}
					currentSelectedItem={currentSelectedItem}
					onCloseFillingModal={onCloseFillingModal}
					onFillForm={onFillForm}
					flags={flags}
					quarter={quarter}
					fixedGeneralAnswers={fixedGeneralAnswers}
					fixedInfoAnswers={fixedInfoAnswers}
					fixedSoundAnswers={fixedSoundAnswers}
					mobileGeneralAnswers={mobileGeneralAnswers}
					mobileInfoAnswers={mobileInfoAnswers}
					mobileSoundAnswers={mobileSoundAnswers}
					fixedGeneralDetails={fixedGeneralDetails}
					fixedInfoDetails={fixedInfoDetails}
					fixedSoundDetails={fixedSoundDetails}
					mobileGeneralDetails={mobileGeneralDetails}
					mobileInfoDetails={mobileInfoDetails}
					mobileSoundDetails={mobileSoundDetails}
					onReValidate={onReValidate}
					reportMethod={reportMethod}
				/>
			)}
		</>
	)
}
